window.addEventListener('load', function() {
    const loader = document.getElementById('loader');
    
    // Set opacity to 0 to fade out
    //loader.style.opacity = '0';
    
    // After the transition, set display to 'none' to remove the loader from the document flow
    setTimeout(function() {
        loader.style.display = 'none';
    }, 1500); // Matches the duration of the CSS transition (0.5s)
});
